import api from "./api";

const url = "compliance-category";

const AllCategory = () => api.get(`${url}/read-compliance-category`);

const FindCategoryById = (id) => api.get(`${url}/read-compliance-category-by-id/${id}`);

export { AllCategory, FindCategoryById };
